import ApiClient from "../ApiClient";
import AnnualAdministration from "../../models/admin/annual-administration/AnnualAdministration";

export default class AnnualAdministrationApiClient {
  apiClient: ApiClient;
  urlPrefix: string = "admin/annual-administrations/";

  constructor() {
    this.apiClient = new ApiClient();
  }

  async getAnnualAdministrations() {
    const administrations = await this.apiClient.get(this.urlPrefix);

    return administrations as Array<AnnualAdministration>;
  }

  async updateAnnualAdministration(annualAdministration: AnnualAdministration) {
    await this.apiClient.put(
      `${this.urlPrefix}${annualAdministration.id}`,
      annualAdministration
    );
  }
}
